const ow_catalog= document.querySelector('#ow_catalog') ;
const catalog_option = document.querySelectorAll('.ow-catalog-option');

catalog_option.forEach(element => {
     element.addEventListener('click', event => {
          event.preventDefault();

          const { option } = event.currentTarget.dataset;
          ow_catalog.dataset.selected = option;
     });
});

whenAvailable('$',function() {
$(function(){
     whenAvailable('slick',function() {
       $('.slick-revolving').on('init', function(event, slick){
         whenAvailable('lazyload', function(){
           setTimeout(function() {
             initLazyload();
           }, 500);
         });
       });
   
       function initSlickRevolving() {
         let slick_intialized = $('.slick-revolving').hasClass('slick-initialized');
   
         if ( !slick_intialized) {
           $('.slick-revolving')?.slick({
             mobileFirst: true,
             infinite: false,
             slidesToShow: 1,
             slidesToScroll: 1,
             centerMode: true,
             centerPadding: '8vw',
             dots: true,
             prevArrow: '<div class="arrow-prev d-lg-flex"><svg class="d-none d-lg-block ms-auto me-3 me-xl-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M59.74 115.2a2.59 2.59 0 0 1-3.66 0L.76 59.8a2.58 2.58 0 0 1 0-3.65L56.08.76a2.58 2.58 0 0 1 3.66 3.65L6.24 58l53.5 53.56a2.59 2.59 0 0 1 0 3.66z"></path></svg></div>',
             nextArrow: '<div class="arrow-next d-lg-flex"><svg class="d-none d-lg-block ms-3 ms-xl-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M.76.76a2.58 2.58 0 0 1 3.65 0l55.33 55.4a2.58 2.58 0 0 1 0 3.65L4.4 115.2a2.58 2.58 0 1 1-3.65-3.65L54.26 58 .76 4.42a2.59 2.59 0 0 1 0-3.66z"></path></svg></div>',
             responsive: [
               {
                 breakpoint: 767,
                 settings: {
                   centerMode: true,
                   centerPadding: 'calc(100vw / 8)'
                 }
               },
               {
                 breakpoint: 1500,
                 settings: {
                   centerMode: true,
                   centerPadding: 'calc(100vw / 7)'
                 }
               }
             ]
           });
           /**
            * Stack all images and show based on the current slide index
            * Works for image background slider to transition or animate smoothly
            */
           $('.slick-revolving').on('afterChange', function(event, slick, currentSlide, nextSlide){
             // slider images
             $(`.image-slide`).removeClass("active")
             $(`.image-slider-bg-${currentSlide}`).addClass("active")
   
             //frame shadow highlight
             $(`.card-border`).removeClass("active")
             $(`.slider-${currentSlide} .card-border`).addClass("active")
   
           });
         }
       }
       initSlickRevolving();
       window.onresize = () => { initSlickRevolving() }
     });
   
});
});  